import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { CustomerIdentificationType, ICustomerIdentificationType } from '../../../../customer/models/enums/customer-identification-type.enum';
import { CustomerType } from '../../../../customer/models/enums/customer-type.enum';
import { CommonDetailViewModel } from '../../../../customer/models/views/common-detail-view.model';
import { IndividualDetailViewModel } from '../../../../customer/models/views/individual-detail-view.model';
import { OrganizationDetailViewModel } from '../../../../customer/models/views/organization-detail-view.model';
import { CustomerService } from '../../../../customer/shared/customer.service';
import { BusinessTransactionType, IBusinessTransactionType } from '../../../../foundation/models/enums/business-transaction-type.enum';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { ValidationStateModel } from '../../../../shared/models/validation-results/validation-state.model';
import { ValidationModel } from '../../../../shared/models/validation-results/validation.model';
import { BusinessTransactionService } from '../../../../shared/services/business-transaction/business-transaction.service';
import { MvdModalService } from '../../../../shared/services/modal/mvd-modal.service';
import { ControlValidationMessagesService } from '../../../../shared/validators/control-validation-messages.service';
import { VehicleService } from '../../../../vehicle/services/vehicle.service';
import { INmvtisActionTakenType, NmvtisActionTakenType } from '../../../models/enums/nmvtis-action-taken-type.enum';
import { INmvtisAgencyStatusType, NmvtisAgencyStatusType } from '../../../models/enums/nmvtis-agency-status-type.enum';
import { INmvtisFindingType, NmvtisFindingType } from '../../../models/enums/nmvtis-finding-type.enum';
import { INmvtisStolenVehicleReportStatusType, NmvtisStolenVehicleReportStatusType } from '../../../models/enums/nmvtis-stolen-vehicle-report-status-type.enum';
import { INmvtisVehiclePartStolenType, NmvtisVehiclePartStolenType } from '../../../models/enums/vehicle-parts-stolen-type.enum';
import { VehicleOwnershipModel } from '../../../models/vehicle-ownership.model';
import { AAMVAIntegrationService } from '../../../services/aamvaIntegration.service';
import { NMVTISMessageModel } from '../../models/nmvtis-message.model';
import { VehiclePossibleStolenReport } from '../../models/psvr.model';
import { CustomerManageService } from 'app/customer/shared/customer-manage.service';
import { CustomerName } from 'app/customer/models/customer-name.model';

@Component({
    selector: 'psvr',
    templateUrl: './psvr.html',
    inputs: ['nmvtisMessageModel'],
    outputs: ['onSaved', 'onCancel', 'onValidationErrors']
})
export class PsvrComponent extends BaseComponent implements OnInit {

    public psvrForm: UntypedFormGroup;
    public dataLoaded = false;
    public nmvtisMessageModel: NMVTISMessageModel;
    public existingReport: VehiclePossibleStolenReport;
    public previousReport: VehiclePossibleStolenReport;
    public metadata: any; // business transaction metadata

    public onSaved: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onCancel: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onValidationErrors: EventEmitter<ValidationModel> = new EventEmitter<ValidationModel>();
    public showPreviousReport: boolean;

    public itemModelYearDate: string;
    public vehicleMakeCode: string;
    public itemModelName: string;

    public ownerName: string; // owner name
    public ownerIdentificationNumber: string; // owner Identification Number
    public ownerIdentificationTypeId: number;
    private ownerId: number;

    public agentName: string; // agent name
    public agentIdentificationNumber: string; // agent Identification Number
    public agentIdentificationTypeId: number;

    public previousOwnerName: string; // previous report owner name
    public previousOwnerNumber: string; // previous report owner Identification Number
    public previousOwnerIdentificationTypeId: number;

    public previousAgentName: string; // previous report agent name
    public previousAgentNumber: string; // previous report agent Identification Number
    public previousAgentIdentificationTypeId: number;

    private customerType: CustomerType = new CustomerType();
    private customerNameId: number;
    private agentNameId: number;
    private name: CustomerName;

    private findingTypesActionTypes: any[];

    public customerIdentificationTypes: ICustomerIdentificationType[];
    public findingTypes: INmvtisFindingType[];
    public actionTakenTypes: INmvtisActionTakenType[];
    public filteredActionTakenTypes: INmvtisActionTakenType[];
    public stolenVehicleReportStatusTypes: INmvtisStolenVehicleReportStatusType[];
    public agencyStatusTypes: INmvtisAgencyStatusType[];
    public vehiclePartStolenTypes: INmvtisVehiclePartStolenType[];
    public businessTransactionTypes: IBusinessTransactionType[];

    constructor(
        private fb: UntypedFormBuilder,
        private _vehicleService: VehicleService,
        private _businessTransactionService: BusinessTransactionService,
        private _customerService: CustomerService,
        private _aamvaIntegrationService: AAMVAIntegrationService,
        public modalService: MvdModalService,
        private _customerManageService: CustomerManageService,
        private toastService: MessageService
    ) {
        super();

        this.psvrForm = this.fb.group({

            'referredMVDTypeID': [''],
            'calledReportingAgencyTypeID': [''],
            'leCalledTypeID': [''],
            'agencyStatusTypeID': [''],
            'findingTypeID': ['', ControlValidationMessagesService.requireSelectedItem],
            'actionTypeID': ['', ControlValidationMessagesService.requireSelectedItem],
            'leStatusTypeID': [''], // its a nullable field
            'vehiclePartStolenTypeId': [''],
            'nmvtisReportingAgentName': [''],
            'nmvtisReportingAgentBadgeNumber': [''],
            'leAgentName': [''],
            'leaBadgeNumber': [''],
            'previousRemarks': [''],
            'reasonToProceed': [''],
            'previousReportnmvtisReportingAgencyRemarks': [''],
            'previousReportleaRemarks': [''],
            'previousReportreasonToProceed': [''],
            'previousReportadditionalRemarks': [''],
            'existingReportpreviousRemarks': ['']

            // [ngModelOptions]="{standalone: true}" [(ngModel)]="existingReport.previousRemarks"
        });

        const nmvtisReportingAgencyRemarksValidator = new UntypedFormControl('', Validators.compose([Validators.maxLength(256)]));
        this.psvrForm.addControl('nmvtisReportingAgencyRemarks', nmvtisReportingAgencyRemarksValidator);

        const additionalRemarksValidator = new UntypedFormControl('', Validators.compose([Validators.maxLength(256)]));
        this.psvrForm.addControl('additionalRemarks', additionalRemarksValidator);

        const leaRemarksValidator = new UntypedFormControl('', Validators.compose([Validators.maxLength(256)]));
        this.psvrForm.addControl('leaRemarks', leaRemarksValidator);
    }

    public updateView() {
        if (this.existingReport) {
            this.psvrForm.get('referredMVDTypeID').setValue(this.existingReport.isReferredMVD);
            this.psvrForm.get('calledReportingAgencyTypeID').setValue(this.existingReport.isNMVTISReportingAgencyCalled);
            this.psvrForm.get('leCalledTypeID').setValue(this.existingReport.isLEACalled);
            this.psvrForm.get('agencyStatusTypeID').setValue(this.existingReport.nmvtisReportingAgencyStatusTypeId);
            this.psvrForm.get('findingTypeID').setValue(this.existingReport.nmvtisFindingTypeId);
            this.psvrForm.get('actionTypeID').setValue(this.existingReport.nmvtisActionTakenTypeId);
            this.psvrForm.get('leStatusTypeID').setValue(this.existingReport.leaStatusTypeId);
            this.psvrForm.get('vehiclePartStolenTypeId').setValue(this.existingReport.vehiclePartStolenTypeId);
            this.psvrForm.get('nmvtisReportingAgentName').setValue(this.existingReport.nmvtisReportingAgentName);
            this.psvrForm.get('nmvtisReportingAgentBadgeNumber').setValue(this.existingReport.nmvtisReportingAgentBadgeNumber);
            this.psvrForm.get('leAgentName').setValue(this.existingReport.leAgentName);
            this.psvrForm.get('leaBadgeNumber').setValue(this.existingReport.leaBadgeNumber);
            this.psvrForm.get('previousRemarks').setValue(this.existingReport.previousRemarks);

            this.psvrForm.get('nmvtisReportingAgencyRemarks').setValue(this.existingReport.nmvtisReportingAgencyRemarks);
            this.psvrForm.get('additionalRemarks').setValue(this.existingReport.additionalRemarks);
            this.psvrForm.get('leaRemarks').setValue(this.existingReport.leaRemarks);

            this.psvrForm.get('reasonToProceed').setValue(this.existingReport.reasonToProceed);
            this.psvrForm.get('existingReportpreviousRemarks').setValue(this.existingReport.previousRemarks);
        }

        if (this.previousReport) {
            this.psvrForm.get('previousReportnmvtisReportingAgencyRemarks').setValue(this.previousReport.nmvtisReportingAgencyRemarks);
            this.psvrForm.get('previousReportleaRemarks').setValue(this.previousReport.leaRemarks);
            this.psvrForm.get('previousReportreasonToProceed').setValue(this.previousReport.reasonToProceed);
            this.psvrForm.get('previousReportadditionalRemarks').setValue(this.previousReport.additionalRemarks);
        }

        this.psvrForm.get('previousRemarks').disable();
        this.psvrForm.get('previousReportnmvtisReportingAgencyRemarks').disable();
        this.psvrForm.get('previousReportleaRemarks').disable();
        this.psvrForm.get('previousReportadditionalRemarks').disable();
        this.psvrForm.get('existingReportpreviousRemarks').disable();
    }

    public updateModel() {
        if (this.existingReport) {
            this.existingReport.isReferredMVD = this.psvrForm.get('referredMVDTypeID').value;
            this.existingReport.isNMVTISReportingAgencyCalled = this.psvrForm.get('calledReportingAgencyTypeID').value;
            this.existingReport.isLEACalled = this.psvrForm.get('leCalledTypeID').value;
            this.existingReport.nmvtisReportingAgencyStatusTypeId = this.psvrForm.get('agencyStatusTypeID').value;
            this.existingReport.nmvtisFindingTypeId = this.psvrForm.get('findingTypeID').value;
            this.existingReport.nmvtisActionTakenTypeId = this.psvrForm.get('actionTypeID').value;
            this.existingReport.leaStatusTypeId = this.psvrForm.get('leStatusTypeID').value;
            this.existingReport.vehiclePartStolenTypeId = this.psvrForm.get('vehiclePartStolenTypeId').value;
            this.existingReport.nmvtisReportingAgentName = this.psvrForm.get('nmvtisReportingAgentName').value;
            this.existingReport.nmvtisReportingAgentBadgeNumber = this.psvrForm.get('nmvtisReportingAgentBadgeNumber').value;
            this.existingReport.leAgentName = this.psvrForm.get('leAgentName').value;
            this.existingReport.leaBadgeNumber = this.psvrForm.get('leaBadgeNumber').value;
            this.existingReport.previousRemarks = this.psvrForm.get('previousRemarks').value;

            this.existingReport.nmvtisReportingAgencyRemarks = this.psvrForm.get('nmvtisReportingAgencyRemarks').value;
            this.existingReport.additionalRemarks = this.psvrForm.get('additionalRemarks').value;
            this.existingReport.leaRemarks = this.psvrForm.get('leaRemarks').value;

            this.existingReport.reasonToProceed = this.psvrForm.get('reasonToProceed').value;

            // this control is disabled, duplicate of other field
            // this.existingReport.previousRemarks = this.psvrForm.get('existingReportpreviousRemarks').value;
        }

        if (this.previousReport) {
            this.previousReport.nmvtisReportingAgencyRemarks = this.psvrForm.get('previousReportnmvtisReportingAgencyRemarks').value;
            this.previousReport.leaRemarks = this.psvrForm.get('previousReportleaRemarks').value;
            this.previousReport.reasonToProceed = this.psvrForm.get('previousReportreasonToProceed').value;
            this.previousReport.additionalRemarks = this.psvrForm.get('previousReportadditionalRemarks').value;
        }

        /// /previousReport.leaRemarks
    }
    async ngOnInit() {
        this.showPreviousReport = false;
        const nmvtisResponse = this.nmvtisMessageModel.nmvtisResponse;

        this.findingTypesActionTypes = await this._aamvaIntegrationService.getPsvrFindingActionTakenMap().pipe(first()).toPromise();

        let individualDetails: CommonDetailViewModel;
        // get transaction metadata: vehicle Id and agentId
        this.metadata = await this._businessTransactionService.getTransactionMetaData(this.nmvtisMessageModel.businessTransactionId.toString()).pipe(first()).toPromise();
        this.name = await this._customerManageService.getCustomerLegalName(this.metadata.agentId).pipe(first()).toPromise();
        if (this.name) {
            this.agentNameId = this.name.customerNameId;
        }
        const vehicleId: number = this.metadata.itemKeyCollection.find(s => +s.businessTransactionItemKeyTypeId === 2).itemKeyId;

        const vehicle = await this._vehicleService.getVehicleComposite(vehicleId).pipe(first()).toPromise();
        this.itemModelYearDate = vehicle.modelYear.toString(); // refer CC 54935
        this.itemModelName = vehicle.modelDisplayValue;
        this.vehicleMakeCode = vehicle.makeDisplayValue;

        const vehicleOwnershipModel: VehicleOwnershipModel = await this._vehicleService.getActiveVehicleOwnershipByVehicleId(vehicleId).pipe(first()).toPromise();
        // populate owner if active vehicle ownership is found
        if (vehicleOwnershipModel && vehicleOwnershipModel.ownershipCustomerRelationships) {
            const owner = vehicleOwnershipModel.ownershipCustomerRelationships.find(x => x.ownershipRoleTypeID == 1 || x.ownershipRoleSequence == 1).customer;
            individualDetails = await this._customerService.getCustomer(owner.customerNumberID).pipe(first()).toPromise();
            const ownerDetails = this.populatePreviousCustomerData(individualDetails);

            this.ownerName = ownerDetails.customerName;
            this.ownerIdentificationTypeId = ownerDetails.customerIdentificationTypeId;
            this.ownerIdentificationNumber = ownerDetails.customerIdentificationNumber;
            this.ownerId = owner.customerNumberID;
        } else { // populate from the transaction owner
            this.ownerId = this.metadata.itemKeyCollection.find(s => +s.businessTransactionItemKeyTypeId === 1).itemKeyId;
            individualDetails = await this._customerService.getCustomer(this.ownerId).pipe(first()).toPromise();
            const ownerDetails = this.populatePreviousCustomerData(individualDetails);
            this.ownerName = ownerDetails.customerName;
            this.ownerIdentificationTypeId = ownerDetails.customerIdentificationTypeId;
            this.ownerIdentificationNumber = ownerDetails.customerIdentificationNumber;
        }

        individualDetails = await this._customerService.getCustomer(this.metadata.agentId).pipe(first()).toPromise();
        const customerDetails = this.populatePreviousCustomerData(individualDetails);
        this.agentIdentificationNumber = customerDetails.customerIdentificationNumber;
        this.agentIdentificationTypeId = customerDetails.customerIdentificationTypeId;
        this.agentName = customerDetails.customerName;

        this.existingReport = await this._aamvaIntegrationService.getPsvrByVin(this.nmvtisMessageModel.nmvtisResponse.vehicleSummary.vehicleIdentification, new NmvtisStolenVehicleReportStatusType().InProgress.id).pipe(first()).toPromise();

        // for a case when there is already a report filled by another agent on the same vehicle
        this.previousReport = await this._aamvaIntegrationService.getPsvrByVin(this.nmvtisMessageModel.nmvtisResponse.vehicleSummary.vehicleIdentification, new NmvtisStolenVehicleReportStatusType().Completed.id).pipe(first()).toPromise();

        this.setDefaultValues();
        this.dataLoaded = true;
    }

    setDefaultValues() {
        this.findingTypes = new NmvtisFindingType().GetAll();
        this.actionTakenTypes = new NmvtisActionTakenType().GetAll();
        this.stolenVehicleReportStatusTypes = new NmvtisStolenVehicleReportStatusType().GetAll();
        this.agencyStatusTypes = new NmvtisAgencyStatusType().GetAll();
        this.vehiclePartStolenTypes = new NmvtisVehiclePartStolenType().GetAll();
        this.businessTransactionTypes = new BusinessTransactionType().GetAll();
        this.customerIdentificationTypes = new CustomerIdentificationType().GetAll();

        if (!this.existingReport) {
            this.existingReport = new VehiclePossibleStolenReport();
            this.existingReport.nmvtisFindingTypeId = 0;
            this.existingReport.nmvtisActionTakenTypeId = 0;
            this.existingReport.leaStatusTypeId = 0;
            this.existingReport.nmvtisReportingAgencyStatusTypeId = 0;
            this.existingReport.vehiclePartStolenTypeId = 0;

            this.existingReport.nmvtisvin = this.nmvtisMessageModel.nmvtisResponse.vehicleSummary.vehicleIdentification;
            this.existingReport.businessTransactionTypeId = +this.metadata.businessTransactionTypeId;

            this.existingReport.customerNameId = this.customerNameId; // TODO: Revisit again.
            this.existingReport.customerNumberId = this.ownerId;
            this.existingReport.agentCustomerNameId = this.agentNameId;
            this.existingReport.agentCustomerNumberId = this.metadata.agentId; // TODO: Revisit again
            this.existingReport.reportPreparedDate = new Date();

            this.existingReport.nmvtisMake = this.vehicleMakeCode;
            this.existingReport.nmvtisModelYear = +this.itemModelYearDate;
            this.existingReport.nmvtisModel = this.itemModelName;

            this.existingReport.nmvtisCaseNumber = this.nmvtisMessageModel.nmvtisResponse.theftReport.theftReportCaseId;
            this.existingReport.nmvtisReportingAgency = this.nmvtisMessageModel.nmvtisResponse.theftReport.theftReportHolderAgencyName;
            this.existingReport.nmvtisReportingJurisdiction = this.nmvtisMessageModel.nmvtisResponse.theftReport.theftReportHolderJurisdictionName;
            this.existingReport.nmvtisTheftStatusDate = this.nmvtisMessageModel.nmvtisResponse.theftReport.statusDate;
            this.existingReport.isPartsStolen = this.nmvtisMessageModel.nmvtisResponse.theftReport.vehiclePartIndicator;

        }

        const filteredFindingActionTypes: number[] = this.findingTypesActionTypes.filter(s => s.nmvtisFindingTypeId === +this.existingReport.nmvtisFindingTypeId)
            .map(s => +s.nmvtisActionTakenTypeId);
        this.filteredActionTakenTypes = this.actionTakenTypes.filter(s => filteredFindingActionTypes.indexOf(s.id) > -1);

        this.updateView();
    }

    // refer US 27033 10.9
    // show the free form field if the finding type is any of the ok to process type
    isFindingOkToProceed() {
        return +this.psvrForm.get('findingTypeID').value === new NmvtisFindingType().OktoprocessperReportingAgency.id
            || +this.psvrForm.get('findingTypeID').value === new NmvtisFindingType().OktoprocessperMVDEnforcement.id
            || +this.psvrForm.get('findingTypeID').value === new NmvtisFindingType().OktoprocessperLocalLawEnforcement.id;
    }

    // close out the previous report and show the existing report
    onCancelClick() {
        if (this.showPreviousReport) {
            this.showPreviousReport = false;
        } else {
            this.onCancel.emit(true);
        }
    }

    async onSaveClick() {
        this.updateModel();

        if (!this.existingReport.isLEACalled) {
            this.existingReport.leaStatusTypeId = null; // since it's a nullable foreign key
            this.existingReport.leaBadgeNumber = null;
            this.existingReport.leAgentName = null;
            this.existingReport.leaRemarks = null;
        }

        if (!this.existingReport.isNMVTISReportingAgencyCalled) {
            this.existingReport.nmvtisReportingAgencyStatusTypeId = null; // it's not null in the database and should trigger the validation message
            this.existingReport.nmvtisReportingAgentBadgeNumber = null;
            this.existingReport.nmvtisReportingAgentName = null;
            this.existingReport.nmvtisReportingAgencyRemarks = null;
        }

        if (this.psvrForm.valid) {
            this.existingReport.vehiclePartStolenTypeId = +this.existingReport.vehiclePartStolenTypeId;
            this.existingReport.nmvtisFindingTypeId = +this.existingReport.nmvtisFindingTypeId;
            this.existingReport.leaStatusTypeId = +this.existingReport.leaStatusTypeId;
            this.existingReport.nmvtisReportingAgencyStatusTypeId = +this.existingReport.nmvtisReportingAgencyStatusTypeId;

            if (!this.existingReport.isPartsStolen) {
                this.existingReport.isPartsStolen = false;
            }
            if (!this.existingReport.vehiclePartStolenTypeId) {
                this.existingReport.vehiclePartStolenTypeId = null; // since it's a nullable foreign key
            }
            if (!this.existingReport.leaStatusTypeId) {
                this.existingReport.leaStatusTypeId = null; // since it's a nullable foreign key
                this.existingReport.leaBadgeNumber = null;
                this.existingReport.leAgentName = null;
                this.existingReport.leaRemarks = null;
            }

            if (!this.existingReport.nmvtisReportingAgencyStatusTypeId) {
                this.existingReport.nmvtisReportingAgencyStatusTypeId = null; // since it's a nullable foreign key
                this.existingReport.nmvtisReportingAgentBadgeNumber = null;
                this.existingReport.nmvtisReportingAgentName = null;
                this.existingReport.nmvtisReportingAgencyRemarks = null;
            }

            this.existingReport.ownerCustomerIdentificationTypeId = +this.ownerIdentificationTypeId;
            this.existingReport.agentCustomerIdentificationTypeId = +this.agentIdentificationTypeId;

            const errors: string[] = this.isAgencyStatusConsistentWithFinding();
            if (errors && errors.length) {
                this.onValidationErrors.emit(this.createValidationMessages(errors));
                return;
            } else {
                this.existingReport.businessTransactionNumberId = +this.nmvtisMessageModel.businessTransactionId;
                this.existingReport.businessTransactionTypeId = +this.metadata.businessTransactionTypeId;
                this.existingReport.nmvtisStolenVehicleReportStatusTypeId = 0; // just to escape from null

                if (!this.existingReport.nmvtisReportingAgency) { // refer BUG 54954
                    await this.modalService.alert()
                        .title('Report Saved')
                        .body('Reporting Agency information not available; contact Local Law Enforcement to confirm vehicle status.')
                        .okBtn('Close').open();
                    this.existingReport.nmvtisReportingAgency = ' ';
                }

                const results = await this._aamvaIntegrationService.savePsvr(this.existingReport).pipe(first()).toPromise();

                const validationResults = results.validationResults;
                if (validationResults && validationResults.length) {
                    this.onValidationErrors.emit(new ValidationModel(results));
                    return;
                }

                this.existingReport = results;

                if (this.existingReport.nmvtisStolenVehicleReportStatusTypeId === 2) {
                    this.psvrForm.disable();
                    // window.scrollTo(0, 0);
                    this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Report saved successfully with Completed status.' });
                    await this.modalService.alert()
                        .title('Report Saved')
                        .body('Stolen Vehicle Report status is saved with a status of Completed.')
                        .okBtn('Close').open();
                    this.onValidationErrors.emit(new ValidationModel(null));
                    this.onSaved.emit(true); // let Integration know that a psvr has been saved.});

                } else if (this.existingReport.nmvtisStolenVehicleReportStatusTypeId === 1) {
                    // window.scrollTo(0, 0); // TODO: it's not working. Find a workaround
                    this.toastService.add({ severity: 'success', summary: 'Success', detail: 'Report saved successfully with in-progress status.' });
                    await this.modalService.alert().title('Report Saved')
                        .body('Stolen Vehicle Report status is In-Progress; prepare Return Sheet for the customer.')
                        .okBtn('Close').open();
                    this.showHoldModalOverlay(this.nmvtisMessageModel.businessTransactionId, this.metadata.businessTransactionTypeId);
                    this.onValidationErrors.emit(new ValidationModel(null));

                    if (+this.metadata.businessTransactionTypeId == new BusinessTransactionType().PrintTitle.id) { // refer 94308
                        this.onSaved.emit(true); // let Integration know that a psvr has been saved.});
                    }
                }
            }
        } else {
            this.psvrForm.markAsTouched();
            (<UntypedFormControl> this.psvrForm.controls['findingTypeID']).markAsTouched();
            (<UntypedFormControl> this.psvrForm.controls['agencyStatusTypeID']).markAsTouched();
            (<UntypedFormControl> this.psvrForm.controls['actionTypeID']).markAsTouched();
        }
        // window.scrollTo(0, 0);
        // window.scroll(0, 0);
    }

    // refer US 29924
    private isAgencyStatusConsistentWithFinding(): string[] {
        const errors: string[] = new Array<string>();

        if (this.existingReport.leaStatusTypeId === new NmvtisAgencyStatusType().ReferToRemarks.id && !this.existingReport.leaRemarks) {
            errors.push('LE remarks are required when the status is Refer To Remarks.');
        }

        if (this.existingReport.nmvtisReportingAgencyStatusTypeId === new NmvtisAgencyStatusType().ReferToRemarks.id && !this.existingReport.nmvtisReportingAgencyRemarks) {
            errors.push('Reporting agency remarks are required when the status is Refer To Remarks.');
        }

        if (new NmvtisAgencyStatusType().Vehicleconfirmedstolen.id === this.existingReport.nmvtisReportingAgencyStatusTypeId
            && new NmvtisFindingType().OktoprocessperReportingAgency.id === this.existingReport.nmvtisFindingTypeId) {
            errors.push('Agency Status is not consistent with Finding selected.');
        }

        if (new NmvtisAgencyStatusType().Vehiclehasbeenrecovered.id === this.existingReport.nmvtisReportingAgencyStatusTypeId
            && new NmvtisFindingType().Vehicleconfirmedstolen.id === this.existingReport.nmvtisFindingTypeId) {
            errors.push('Agency Status is not consistent with Finding selected.');
        }
        if (new NmvtisAgencyStatusType().Vehicleconfirmedstolen.id === this.existingReport.leaStatusTypeId
            && new NmvtisFindingType().OktoprocessperLocalLawEnforcement.id === this.existingReport.nmvtisFindingTypeId) {
            errors.push('Law Enforcement Status is not consistent with Finding selected.');
        }
        if (new NmvtisAgencyStatusType().Vehiclehasbeenrecovered.id === this.existingReport.leaStatusTypeId
            && new NmvtisFindingType().Vehicleconfirmedstolen.id === this.existingReport.nmvtisFindingTypeId) {
            errors.push('Law Enforcement Status indicates vehicle has been recovered.');
        }
        if (!this.existingReport.isReferredMVD
            && new NmvtisFindingType().OktoprocessperMVDEnforcement.id === this.existingReport.nmvtisFindingTypeId) {
            errors.push('No MVD Enforcement Inspection referral was made; not consistent with Finding selected.');
        }
        if (!this.existingReport.isPartsStolen
            && (new NmvtisFindingType().Stolenpartisamajorcomponentpart.id === this.existingReport.nmvtisFindingTypeId
            || new NmvtisFindingType().Stolenpartnotamajorcomponentpart.id === this.existingReport.nmvtisFindingTypeId)) {
            errors.push('NMVTIS Theft Report does not report Stolen Parts.');
        }
        if (!this.existingReport.isLEACalled && (new NmvtisFindingType().Vehicleconfirmedstolen.id === this.existingReport.nmvtisFindingTypeId)) {
            errors.push('When a vehicle is confirmed stolen, Local Law Enforcement must be called.');
        }

        if (this.existingReport.vehiclePartStolenTypeId && this.existingReport.vehiclePartStolenTypeId !== new NmvtisVehiclePartStolenType().OtherNotAMajorComponentPart.id
            && this.existingReport.vehiclePartStolenTypeId !== new NmvtisVehiclePartStolenType().NotProvidedByStolenPartsDescription.id
            && this.existingReport.nmvtisFindingTypeId === new NmvtisFindingType().Stolenpartnotamajorcomponentpart.id) {
            errors.push('The Stolen Component Part selected is a major component part.');
        }
        if (this.existingReport.vehiclePartStolenTypeId === new NmvtisVehiclePartStolenType().OtherNotAMajorComponentPart.id
            && this.existingReport.nmvtisFindingTypeId === new NmvtisFindingType().Stolenpartisamajorcomponentpart.id) {
            errors.push('The Stolen Component Part selected is NOT a major component part.');
        }

        return errors;
    }

    private populatePreviousCustomerData(customerDetails: CommonDetailViewModel): any {
        const self = this;
        let customerName: string;
        let customerIdentificationTypeId: number;
        let customerIdentificationNumber: string;

        const customerIdentificationPriorityOrder: number[] = [1, 2, 4, 3, 11, 5, 10, 13, 12, 6, 14, 15, 16, 17, 18, 20, 7, 9, 8];

        if (customerDetails.customerTypeId == this.customerType.Individual.id) {
            customerName = (customerDetails as IndividualDetailViewModel).nameDetail.firstName + ' ' + (customerDetails as IndividualDetailViewModel).nameDetail.lastName;
            this.customerNameId = (customerDetails as IndividualDetailViewModel).nameDetail.customerNameId;

        } else if (customerDetails.customerTypeId == this.customerType.Organization.id) {
            customerName = (customerDetails as OrganizationDetailViewModel).nameDetail.organizationName;
            this.customerNameId = (customerDetails as OrganizationDetailViewModel).nameDetail.customerNameId;
        }

        if (customerDetails.identifications) {
            for (const priorityIdentification of customerIdentificationPriorityOrder) {
                const identification = customerDetails.identifications.find(i => i.customerIdentificationTypeId == priorityIdentification);
                if (identification) {
                    customerIdentificationTypeId = identification.customerIdentificationTypeId;
                    customerIdentificationNumber = identification.customerIdentificationValue;
                    break;
                }
            }
        }

        const customer: any = {
            customerName: customerName,
            customerIdentificationTypeId: customerIdentificationTypeId,
            customerIdentificationNumber: customerIdentificationNumber
        };

        return customer;
    }

    /**
     * ActionType menu should cascade from findingType chosen.
     * @param event: event.
     */
    public setActionType(event) {

        const filteredFindingActionTypes: number[] = this.findingTypesActionTypes
            .filter(s => s.nmvtisFindingTypeId === +event.target.value)
            .map(s => +s.nmvtisActionTakenTypeId);
        this.filteredActionTakenTypes = this.actionTakenTypes.filter(s => filteredFindingActionTypes.indexOf(s.id) > -1);
        this.psvrForm.get('actionTypeID').setValue(0);
    }

    private createValidationMessages(messages: string[]) {
        const tempErrors = [];
        const state: ValidationStateModel = new ValidationStateModel();
        state.validationType = 'Error';
        for (var message of messages) {
            tempErrors.push({ errorMessage: message, state: state });
        }
        return new ValidationModel(tempErrors);
    }

    // show the modal with the read only information here
    async showReadonlyReport() {
        this.showPreviousReport = true;

        let individualDetails = await this._customerService.getCustomer(this.previousReport.customerNameId).pipe(first()).toPromise();
        let customerDetails = this.populatePreviousCustomerData(individualDetails);

        this.previousOwnerNumber = customerDetails.customerIdentificationNumber;
        this.previousOwnerIdentificationTypeId = customerDetails.customerIdentificationTypeId;
        this.previousOwnerName = customerDetails.customerName;

        individualDetails = await this._customerService.getCustomer(this.previousReport.agentCustomerNameId).pipe(first()).toPromise();
        customerDetails = this.populatePreviousCustomerData(individualDetails);

        this.previousAgentNumber = customerDetails.customerIdentificationNumber;
        this.previousAgentIdentificationTypeId = customerDetails.customerIdentificationTypeId;
        this.previousAgentName = customerDetails.customerName;

    }
    public hasValidationError = (controlName: string, ruleName: string): boolean => this.psvrForm.controls[controlName].dirty &&
            this.psvrForm.controls[controlName].touched &&
            this.psvrForm.controls[controlName].hasError(ruleName);

    private showHoldModalOverlay(businessTransactionId: number, businessTransactionTypeId: number) {

    }

}
